import { createAsyncThunk } from "@reduxjs/toolkit";
import { EventDetailsExportService } from "Bands/services/EventDetailsExportService";
import { BAND_ACTIONS, IEventDetailsExportParams } from "Bands/types";

export const createEventDetailsExport = createAsyncThunk(
  BAND_ACTIONS.createEventDetailsExport,
  async (
    {
      paperSize = "a4",
      showMyPersonalInfo = false,
      ...data
    }: IEventDetailsExportParams,
    { rejectWithValue }
  ) => {
    try {
      const createdItem =
        await EventDetailsExportService.createEventDetailsExport({
          ...data,
          paperSize,
          showMyPersonalInfo,
        });

      const id = Object.values(createdItem?.eventDetailsExport)?.[0]?.attributes
        ?.id;

      return { id };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getEventDetailsExport = createAsyncThunk(
  BAND_ACTIONS.getEventDetailsExport,
  async (id: string, { rejectWithValue }: { rejectWithValue: any }) => {
    try {
      const eventDetailsExport =
        await EventDetailsExportService.getEventDetailsExport(id);

      return eventDetailsExport;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getLastEventDetailsExportSent = createAsyncThunk(
  BAND_ACTIONS.getLastEventDetailsExportSent,
  async (id: string, { rejectWithValue }: { rejectWithValue: any }) => {
    try {
      const eventDetailsExport =
        await EventDetailsExportService.getLastEventDetailsExportSent(id);

      return eventDetailsExport;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
